import React, { useEffect, useMemo } from 'react';
import Main from '../../components/Main/Main';
import Title from '../../components/Title';
import TableMuitFaltaEstoque from '../../components/Table/TableMuiFaltaEstoque';
import { Search, TriangleAlert } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { getEstoqueBaixo } from '../../slices/productSlice';
import { MenuItem, Select } from '@mui/material';
import { getCategoria } from '../../slices/getCategoria';
import { Input } from '@material-tailwind/react';

export const statusEstoque = [
  { status: 'Baixo', id: 'Baixo' },
  { status: 'Email', id: 'Email' },
  { status: 'Aguardando', id: 'Aguardando' },
];
const columns = ['Produto', 'Estoque', 'Min/Max', 'Status', 'Ações'];

const AlertEstoque = () => {
  const { estoqueBaixo } = useSelector((state) => state.product);
  const { categoriasCompra } = useSelector((produto) => produto.categorias);
  const [statusAll, setStatusAll] = React.useState('all');
  const [filtro, setFiltro] = React.useState('');
  const [filtroCategoria, setFiltroCategoria] = React.useState('all');
  const dispatch = useDispatch();

  // const option = useMemo(() => {
  //   categoriasCompra
  //     .flatMap((produto) =>
  //       produto.categorias.map((categoria) => ({
  //         group: produto.nome,
  //         label: categoria.nome.toLowerCase(),
  //         id: categoria.id,
  //       }))
  //     )
  //     .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR', { numeric: true }));
  // });

  const option = useMemo(() => {
    if (!Array.isArray(categoriasCompra)) return []; // segurança caso ainda não carregou

    return categoriasCompra
      .flatMap((produto) =>
        produto.categorias.map((categoria) => ({
          group: produto.nome,
          label: categoria.nome.toLowerCase(),
          id: categoria.id,
        }))
      )
      .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR', { numeric: true }));
  }, [categoriasCompra]);
  const dadosFiltrado = estoqueBaixo.filter((produto) => {
    const search = filtro.toLowerCase();
    const categoria = filtroCategoria === 'all' ? true : produto.categoria === filtroCategoria;
    const status = statusAll === 'all' ? true : produto.statusEstoque === statusAll;

    const buscar = produto.nome.toLowerCase().includes(search) || produto.winthor.includes(search);

    return buscar && status && categoria;
  });

  useEffect(() => {
    dispatch(getEstoqueBaixo());
    dispatch(getCategoria());
  }, []);
  return (
    <Main>
      <Title>
        <div className="flex items-center gap-x-2">
          <TriangleAlert color="yellow" />
          Estoque baixo
        </div>
      </Title>
      <div className="bg-gray-100 p-4 rounded-lg flex items-center gap-x-2 mb-4 justify-between  ml-auto">
        <Input
          placeholder="Buscar Produto"
          className="ppearance-none !border-t-blue-gray-200 placeholder:text-blue-gray-300 placeholder:opacity-100 focus:!border-blue-700 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
          labelProps={{
            className: 'before:content-none after:content-none ',
          }}
          containerProps={{ className: 'w-60' }}
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          icon={<Search />}
        />
        <Select
          className="w-60 bg-white h-10 min-w-[200px]"
          onChange={(e) => setStatusAll(e.target.value)}
          value={statusAll}
        >
          {[...statusEstoque, { status: 'Todos os status', id: 'all' }].map((status, index) => (
            <MenuItem key={status.id} value={status.id}>
              {status.status}
            </MenuItem>
          ))}
        </Select>
        <Select
          width="200px"
          className="w-60 bg-white h-10 min-w-[200px]"
          onChange={(e) => setFiltroCategoria(e.target.value)}
          value={filtroCategoria}
        >
          {[
            {
              label: 'Todas as categorias',
              id: 'all',
            },
            ...option,
          ].map((categoria) => (
            <MenuItem key={categoria.id} value={categoria.id} className="capitalize">
              {categoria.label}
            </MenuItem>
          ))}
        </Select>
      </div>
      <TableMuitFaltaEstoque columns={columns} rows={dadosFiltrado} status={statusEstoque} />
    </Main>
  );
};

export default AlertEstoque;
